const initialState = () => ({
  selectedReport: '',
  reportParameters: {},
  selectedRetail: 0,
  retailListSelectorData: [],
  dimensionFilterData: [],
  gridData: [],
  selectedRetailBusinessParameters: {},
  productSelectorData: []
})

const state = initialState()

// const state = {
//   selectedReport: null,
//   reportParameters: null,
//   selectedRetail: null,
//   retailListSelectorData: null,
//   dimensionFilterData: null,
//   gridData: null,
//   selectedRetailBusinessParameters: {}
// }

const getters = {

}

const mutations = {
  commit_genKeyKpiAnalysis_selectedReport (state, selectedReport) {
    state.selectedReport = selectedReport
  },
  commit_genKeyKpiAnalysis_reportParameters (state, reportParameters) {
    state.reportParameters = reportParameters
  },
  commit_genKeyKpiAnalysis_selectedRetail (state, selectedRetail) {
    state.selectedRetail = selectedRetail
  },
  commit_genKeyKpiAnalysis_retailListSelectorData (state, retailListSelectorData) {
    state.retailListSelectorData = retailListSelectorData
  },
  commit_genKeyKpiAnalysis_selectedRetailBusinessParameters (state, selectedRetailBusinessParameters) {
    state.selectedRetailBusinessParameters = selectedRetailBusinessParameters
  },
  commit_genKeyKpiAnalysis_dimensionFilterData (state, dimensionFilterData) {
    state.dimensionFilterData = dimensionFilterData
  },
  commit_genKeyKpiAnalysis_gridData (state, gridData) {
    state.gridData = gridData
  },
  commit_genKeyKpiAnalysis_productSelectorData (state, productSelectorData) {
    state.productSelectorData = productSelectorData
  },
  commit_genKeyKpiAnalysis_resetState (state) {
    const newState = initialState()
    Object.keys(newState).forEach(key => {
      state[key] = newState[key]
    })
  }
}

export default {
  state,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/generalKeyKpiAnalysis.js